import { render, staticRenderFns } from "./SharePicker.vue?vue&type=template&id=354d6fd4&"
import script from "./SharePicker.vue?vue&type=script&lang=js&"
export * from "./SharePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports